module.exports = __webpack_public_path__ + "img/jerome_baker.b0a5fc1a.png";